import gql from 'graphql-tag';

const TRANSACTION_CREATIVES_BY_CAMPAIGN = gql`
  query transactionCreativeByCampaigns($adProviderId: String!) {
    transactionCreativeByCampaigns(where: { adProviderId: $adProviderId }) {
      id
      adProviderId
      impressions
      transactions
      byDate {
        date
        impressions
        transactions
      }
      creative {
        creativeId
        name
        media
      }
    }
  }
`;

export default TRANSACTION_CREATIVES_BY_CAMPAIGN;
